import { useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getFavorites, getMarketBySlug } from '../utils/api';
import { mapApiItems } from '../utils/marketUtils';

/**
 * 处理收藏详情模式的数据加载
 */
export function useFavoriteDetail({
  isAuthenticated,
  userId,
  activeSection,
  onSectionChange,
  onDataLoad,
  pushToast
}) {
  const params = useParams();
  const location = useLocation();
  const isLoadingRef = useRef(false);
  const favoriteDetailMode = location.pathname.startsWith('/favorites/');

  useEffect(() => {
    if (!favoriteDetailMode) return;
    if (activeSection !== 'favorites') {
      onSectionChange('favorites');
    }

    let cancelled = false;

    (async () => {
      try {
        const slug = params.slug;
        if (!slug) return;

        isLoadingRef.current = true;

        if (isAuthenticated && userId) {
          // 已登录：从收藏列表加载
          const res = await getFavorites(userId);
          const items = Array.isArray(res?.data) ? res.data : [];
          const mapped = mapApiItems(items);

          if (cancelled) return;

          const idx = mapped.findIndex((m) => m.id === slug);

          onDataLoad({
            marketData: mapped,
            activeMarketIndex: idx >= 0 ? idx : 0,
            page: 1,
            hasNext: false,
            favoriteItems: items,
            favoriteSlugs: new Set(items.map((x) => x.slug))
          });
        } else {
          // 未登录：获取单个市场详情
          const res = await getMarketBySlug(slug);

          if (!res || (res.code !== 0 && res.code !== 1) || !res.data) {
            pushToast && pushToast('加载市场详情失败', 'info');
            isLoadingRef.current = false;
            return;
          }

          const item = res.data;
          const mapped = mapApiItems([item]);

          if (cancelled) return;

          onDataLoad({
            marketData: mapped,
            activeMarketIndex: 0,
            page: 1,
            hasNext: false
          });
        }

        setTimeout(() => {
          isLoadingRef.current = false;
        }, 100);
      } catch (e) {
        console.error('加载收藏详情失败:', e);
        isLoadingRef.current = false;
        pushToast && pushToast('加载失败，请稍后重试', 'info');
      }
    })();

    return () => {
      cancelled = true;
      isLoadingRef.current = false;
    };
  }, [favoriteDetailMode, isAuthenticated, userId, params.slug, onSectionChange, onDataLoad, pushToast]);

  return { favoriteDetailMode, isLoadingRef };
}
